import {
  ShieldCheck,
  Lightbulb,
  Leaf,
  TrendingUp,
  Recycle,
  Award,
  GitBranch,
  Sun,
  Factory,
  RadioTower,
  Activity,
  Waves,
  Thermometer,
  Droplets,
} from "lucide-react";

const MAP = {
  ShieldCheck,
  Lightbulb,
  Leaf,
  TrendingUp,
  Recycle,
  Award,
  GitBranch,
  Sun,
  Factory,
  RadioTower,
  Activity,
  Waves,
  Thermometer,
  Droplets,
};

export default function Icon({ name, className }) {
  const Cmp = MAP[name] || Sun;
  return <Cmp className={className} />;
}
